import Swiper from 'swiper/bundle';

if($(".resultate-teaser-slider-swiper.swiper-container").length > 0) {
    const resultate_swiper = new Swiper(".resultate-teaser-slider-swiper.swiper-container", {
        slidesPerView: 'auto',
        loop: false,
        updateOnWindowResize: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: ".swiper-button-next.resultate-teaser-swiper-button",
            prevEl: ".swiper-button-prev.resultate-teaser-swiper-button",
        },
    });
}